import React from "react"; 
import { Link } from "react-router-dom"; 
import Grid from "@mui/material/Grid";
import Sidebar from "../../../components/Apps/FileManager/Sidebar"; 
import MyDrive from "../../../components/Apps/FileManager/MyDrive";
import RecentFiles from "../../../components/Apps/FileManager/MyDrive/RecentFiles";

const FileManager = () => {
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>File Manager</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Apps</li>
          <li>File Manager</li>
        </ul>
      </div>

      <Grid container columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 3 }}>
        <Grid item xs={12} md={4} lg={4} xl={3}>
          <Sidebar />
        </Grid>

        <Grid item xs={12} md={8} lg={8} xl={9}>
          <MyDrive />

          <RecentFiles />
        </Grid>
      </Grid>
    </>
  );
};

export default FileManager;
